import { Paper } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledContainer = styled.div`
  width: max(300px, 100%);
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0 !important;
`;

export const ContentWrapper = styled(Paper)`
  display: flex;
  padding: 10px;
  padding-right: 20px;
  border-radius: 15px !important;
  justify-content: center;
  background: ${theme.palette.primary.dark} !important;
  align-items: center;
  color: ${theme.palette.primary.contrastText} !important;
`;
